import { useEffect, useState } from 'react';
import api from '../utils/api';

// Shared reader for public store settings (admin → Settings).
// Returns the raw settings object; components pick the keys they need.
export default function usePublicSettings() {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    api.get('/settings/public')
      .then(({ data }) => setSettings(data.settings || {}))
      .catch(() => {});
  }, []);

  return settings;
}
